import React, { useEffect, useState } from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import DataTableDemo from '../../../components/generals/datatables/datatable'
import styles from '../../../css/reports/Reports.module.css'
import { getData } from '../../../actions/servicesHttp'
import { formatDate } from '../../../components/generals/charts/utils/DatesFormats'
import { Button, ButtonGroup } from 'reactstrap'
import ToggleButton from 'react-bootstrap/esm/ToggleButton'
import { NavLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Loading from '../../../components/generals/loading'

export default function MisssingDevicesReport () {
  const { t, ready } = useTranslation('missingDevicesReport')
  const { user } = store.getState()
  const role = user.roles
  const navigate = useNavigate()
  const [urlMissingDevicesReport] = useState('reports/missing-devices-report')
  const [missingDevicesReport, setMissingDevicesReport] = useState(null)
  const [statusFilter, setStatusFilter] = useState('open')

  const columns = [
    { field: 'status', header: t('headers.one') },
    { field: 'id_user', header: t('headers.two') },
    { field: 'serial_number', header: t('headers.three') },
    { field: 'type', header: t('headers.four') },
    { field: 'so', header: t('headers.five') },
    { field: 'model', header: t('headers.six') },
    { field: 'last_date', header: t('headers.seven') },
    { field: 'ip_wan', header: t('headers.eight') },
    { field: 'createdAt', header: t('headers.nine') },
    { field: 'user', header: t('headers.ten') },
    { field: 'closeDate', header: t('headers.eleven') },
    { field: 'closeUser', header: t('headers.twelve') }
  ]

  const status = [
    { name: t('button1'), value: 'open' },
    { name: t('button2'), value: 'close' },
    { name: t('button3'), value: 'all' }
  ]

  const getMissingDevicesReport = async (statusFilter) => {
    const response = await getData(urlMissingDevicesReport, JSON.stringify({ statusFilter }), navigate)

    if (response?.status === 200) {
      const devices = response?.data
      const array = []
      devices.forEach((info) => {
        let element
        const userCreate = info.userMissingDevices
        const userClose = info.closeUserMissingDevices
        const device = info.device

        delete info.userMissingDevices
        delete info.closeUserMissingDevices
        delete info.device

        info.closeUser = userClose === null && info.status === 'close' ? t('label1') : userClose === null ? t('noDisponible') : userClose?.user
        info.user = userCreate === null ? t('label1') : userCreate?.user
        info.closeDate = info.closeDate === null ? t('noDisponible') : formatDate(info.closeDate)
        info.createdAt = formatDate(info.createdAt)
        info.status = info.status === 'open' ? t('label2') : t('label3')
        info.type = device.type.toLowerCase()

        const soSplit = device?.so?.split('_-_') || []
        const so = soSplit.length > 1 ? `${soSplit[0]} ${soSplit[1]}` : soSplit[0] || ''
        device.so = so

        const modelSplit = device?.model?.split('_-_') || []
        const model = modelSplit.length > 1 ? `${modelSplit[0]} ${modelSplit[1]}` : modelSplit[0] || ''
        device.model = model

        device.last_date = device.last_date === null ? t('noDisponible') : formatDate(device.last_date)

        element = info
        element = {
          ...element,
          ...device
        }

        array.push(element)
      })
      setMissingDevicesReport(array)
    } else {
      setMissingDevicesReport([])
    }
  }
  useEffect(() => {
    if (ready) {
      getMissingDevicesReport(statusFilter)
    }
  }, [statusFilter, ready])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button4')}
              </Button>
          </NavLink>
        </div>
        <div className={styles.btnsContainer}>
            <ButtonGroup className={styles.dateFilterContainer}>
              {status?.map((state, index) => (
                <ToggleButton
                  key={index}
                  id={`state-${index}`}
                  type="radio"
                  variant="secondary"
                  name="state"
                  value={state.value}
                  checked={state.value === statusFilter}
                  className={styles.btnDateReport}
                  onChange={(e) => {
                    setStatusFilter(e.target.value)
                    setMissingDevicesReport(null)
                  }}
                >
                  {state.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </div>
        <div>
          {missingDevicesReport === null && <Loading color="primary" />}
          {missingDevicesReport !== null && <DataTableDemo
            data={missingDevicesReport}
            reload={() => getMissingDevicesReport(statusFilter)}
            editUsers={false}
            rowStates={false}
            rowSelecteds={false}
            exportsPdf={role?.reportsPage.exportPdfInReport}
            exportsCsv={role?.reportsPage.exportCsvInReport}
            actionDelete={false}
            actionDashboard={false}
            table="missingDevicesReport"
            searchs={['id_user', 'serial_number']}
            columns={columns}
            namePdf={t('namePdf')}
          />}
        </div>
      </div>
    </div>
  )
}
